export const MODAL_TRANSITION_DURATION_MS = 400
